/** @jsx jsx */
import { BadgeVariant, Badge } from "../Badge"
import { IncidentStatus } from "../../types"
import { jsx } from "theme-ui"
import React from "react"

interface IncidentBadgeProps {
  incidentStatusId: IncidentStatus
  className?: string
}

const getIncidentBadgeVariant = (
  incidentStatusId: IncidentStatus
): BadgeVariant => {
  switch (incidentStatusId) {
    case IncidentStatus.DECLARED:
      return BadgeVariant.WARNING
    case IncidentStatus.RESOLVED:
      return BadgeVariant.SUCCESS
  }
}

const formatLabel = (incidentStatusId: IncidentStatus): string => {
  switch (incidentStatusId) {
    case IncidentStatus.DECLARED:
      return "Declared"
    case IncidentStatus.RESOLVED:
      return "Resolved"
  }
}

export const IncidentBadge: React.FC<IncidentBadgeProps> = ({
  className,
  incidentStatusId,
}) => (
  <Badge
    variant={getIncidentBadgeVariant(incidentStatusId)}
    className={className}
  >
    {formatLabel(incidentStatusId)}
  </Badge>
)
